import type { ColumnDef } from "@tanstack/react-table";
import { AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";
import type { CreanceByParty } from "@/lib/reporting.api";
import { formatXafNumber } from "./creancesEngagements.formatters";

export const creanceColumns: ColumnDef<CreanceByParty, any>[] = [
  {
    accessorKey: "partyName",
    header: "Partie",
    cell: ({ row }) => (
      <Link
        to={`/parties/${row.original.partyId}`}
        className="hover:text-brand-gold-dark hover:underline"
      >
        {row.original.partyName}
      </Link>
    ),
  },
  {
    accessorKey: "principalDue",
    header: "Principal dû",
    meta: { align: "right" },
    cell: ({ row }) => formatXafNumber(row.original.principalDue),
  },
  {
    accessorKey: "penaltyDue",
    header: "Pénalités dues",
    meta: { align: "right" },
    cell: ({ row }) => formatXafNumber(row.original.penaltyDue),
  },
  {
    accessorKey: "totalDue",
    header: "Total dû",
    meta: { align: "right" },
    cell: ({ row }) => (
      <span className="font-medium text-body">{formatXafNumber(row.original.totalDue)}</span>
    ),
  },
  {
    id: "overdue",
    header: "",
    cell: ({ row }) =>
      row.original.overdueCount > 0 && (
        <span className="inline-flex items-center gap-1 text-[10px] text-danger-text">
          <AlertTriangle size={10} /> {row.original.overdueCount} en retard
        </span>
      ),
  },
];
